import { createTheme } from '@mui/material/styles';

const makeTheme = (ui) =>
  createTheme({
    palette: {
      primary: { main: ui.primaryButton },
      ui,
    },
  });

export const THEMES = {
  style1: makeTheme({
    header: '#0076f8',
    navigation: '#003876',
    primaryButton: '#0076f8',
    addButton: '#52D55F',
    tab: 'rgba(189, 224, 251, 0.6)',
    tableHeader: '#BDE0FB',
    tableRowOdd: '#FFFFFF',
    tableRowEven: '#EDF4FB',
    tableRowOddHover: '#FFF0B3',
    tableRowEvenHover: '#FFF0B3',
    dgSelected: '#FFE067',
    dgSelectedHover: '#FFF0B3',
    dgSelectedOdd: '#FFE69C',
    dgSelectedEven: '#FFE69C',
    headerOpacity: '0.9',
    headerColor: '#fff',
    navigationItemHover: '#001F41',
    navigationSubItemHover: '#001F41',
    primaryLabel: '#000000',
    dgFilterRow: '#E9F5FE',
    dialogHeader: '#0076f8',
  }),

  style2: makeTheme({
    header: '#ffffff',
    navigation: '#375570',
    primaryButton: '#1d4ed8',
    addButton: '#059669',
    tab: '',
    tableHeader: '#cedfe8',
    tableRowOdd: '#F7F7F7',
    tableRowEven: '#EBEAEA',
    tableRowOddHover: '#EDF4FB',
    tableRowEvenHover: '#EDF4FB',
    dgSelected: '#B3C8D3',
    dgSelectedHover: '#B3C8D3',
    dgSelectedOdd: '#B3C8D3',
    dgSelectedEven: '#B3C8D3',
    headerOpacity: '1',
    headerColor: '#607d8b',
    navigationItemHover: '#1F2937',
    navigationSubItemHover: '#1F2937',
    primaryLabel: '#607d8b',
    dgFilterRow: '#b4c9d4',
    dialogHeader: '#6F9AD8',
  }),
};
